import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Component {
  icon: string;
  title: string;
  description: string;
  elements: string[];
}

interface ProgramComponentsProps {
  components: Component[];
}

const ProgramComponents: React.FC<ProgramComponentsProps> = ({ components }) => {
  return (
    <section className="py-16 lg:py-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-6">
              Three Integrated Components
            </h2>
            <p className="text-lg text-text-secondary max-w-3xl mx-auto leading-relaxed">
              Each component is designed to work in concert, ensuring that strategic frameworks are supported by leadership capability and execution architecture.
            </p>
          </div>

          <div className="space-y-8">
            {components.map((component, index) => (
              <div
                key={index}
                className="bg-surface rounded-lg institutional-border p-8 lg:p-12 hover:institutional-shadow transition-base"
              >
                <div className="flex flex-col lg:flex-row lg:items-start gap-8">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-institutional/10 rounded-lg flex items-center justify-center">
                      <Icon name={component.icon as any} size={32} className="text-institutional" />
                    </div>
                  </div>
                  <div className="flex-1">
                    <h3 className="text-2xl font-bold text-text-primary mb-4">
                      {component.title}
                    </h3>
                    <p className="text-text-secondary mb-6 leading-relaxed">
                      {component.description}
                    </p>
                    <div className="grid sm:grid-cols-2 gap-4">
                      {component.elements.map((element, idx) => (
                        <div key={idx} className="flex items-start">
                          <span className="w-1.5 h-1.5 bg-institutional rounded-full mt-2 mr-3 flex-shrink-0"></span>
                          <span className="text-sm text-text-secondary">{element}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgramComponents;